<template>
    <TprmModal
        open
        title="Exception Details"
        subtitle="Details of the granted exception."
        size="md"
        allow-close
        @close="$emit('close')"
    >
        <div class="ExceptionDetailsModal">
            <div v-if="coverageTypeLabel" class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Coverage Type
                </div>
                <div class="ExceptionDetailsModal__value">
                    {{ coverageTypeLabel }}
                </div>
            </div>
            <div v-if="criterionLabel" class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Criterion
                </div>
                <div class="ExceptionDetailsModal__value">
                    {{ criterionLabel }}
                </div>
            </div>
            <div class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Exception Type
                </div>
                <div class="ExceptionDetailsModal__value">
                    {{ overrideTypeLabel || '—' }}
                </div>
            </div>
            <div v-if="expirationDate" class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Expiration Date
                </div>
                <div class="ExceptionDetailsModal__value">
                    {{ expirationDate }}
                </div>
            </div>
            <div class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Note
                </div>
                <div class="ExceptionDetailsModal__noteText">
                    {{ note || '—' }}
                </div>
            </div>
            <div class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Granted By
                </div>
                <div class="ExceptionDetailsModal__value">
                    {{ grantedBy }}
                </div>
            </div>
            <div class="ExceptionDetailsModal__section">
                <div class="ExceptionDetailsModal__sectionLabel">
                    Date
                </div>
                <div class="ExceptionDetailsModal__value">
                    {{ date }}
                </div>
            </div>
        </div>
        <template #footer>
            <NewButton
                variant="outline"
                color="neutral"
                @click="$emit('close')"
            >
                Close
            </NewButton>
        </template>
    </TprmModal>
</template>

<style lang="scss">
.ExceptionDetailsModal {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__section {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    &__sectionLabel {
        font-size: var(--text-label-size, 12px);
        font-weight: var(--text-label-weight, 600);
        color: var(--eidSecureBlue-50);
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    &__value {
        font-size: var(--text-body-size, 14px);
        color: var(--primary-font-color);
    }

    &__noteText {
        white-space: pre-wrap;
        font-size: var(--text-body-size, 14px);
        line-height: 1.6;
        color: var(--primary-font-color);
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    // PRODUCT-26110 QA fixes4: declares the `close` event this component `$emit`s --
    // without a declared `emits`, Vue 3 warns "Component emitted event 'close' but it is
    // neither declared in the emits option nor as an 'onClose' prop" every time it fires.
    export default defineComponent({
        name: 'ExceptionDetailsModal',
        components: { TprmModal, NewButton },
        props: {
            coverageTypeLabel: {
                type: String as PropType<string>,
                default: '',
            },
            criterionLabel: {
                type: String as PropType<string>,
                default: '',
            },
            overrideTypeLabel: {
                type: String as PropType<string>,
                default: '',
            },
            expirationDate: {
                type: String as PropType<string>,
                default: '',
            },
            note: {
                type: String as PropType<string | null>,
                default: null,
            },
            grantedBy: {
                type: String as PropType<string>,
                default: '',
            },
            date: {
                type: String as PropType<string>,
                default: '',
            },
        },
        emits: [ 'close' ],
    });
</script>
